import { gql } from '@apollo/client';

export default gql`
query GetLanguage($id: ID!) {
  Language(IdIdioma: $id) {
    IdIdioma
    Idioma
  }
}
`;